import { useState,useEffect } from "react";
import { Button, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { deleteWard } from "../../../store/actions/wardsAction";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
import Popup from "../../common/modal/Popup";
import { useNavigate, Link} from 'react-router-dom';
import Loader from "../../common/loader/Loader";
const DeleteWardPopup = ({deleteRec, onHide, deleteModalShow, setDeleteModalShow, setIsDeleted}) => {
    const {
        isRecordUpdated,
        isLoader,
        error: apiError
    } = useSelector(state => {return state.wards});
    const [isAction, setIsAction] = useState(false)
    const [isDone, setIsDone] = useState(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const submitHandler = (mode) => {
        setIsAction(true);
        return dispatch(deleteWard({
                wardId: deleteRec,
            })).then(({payload}) => {

                if (payload?.success) {
                setDeleteModalShow(false)
                onHide()
                setIsDone(true);
                }
                
            })
    }
  

    const hideHandlerRes = () => {
        setIsAction(false)
        setIsDone(false)
        navigate('/')
    }

    return (
        <>
            
            <Popup
                onHide={() => onHide()}
                size="md"
                show={deleteModalShow}
                title={"Delete Ward"}
                footer={
                    <>
                        <Button variant="outline-secondary model-btn" className="me-4" onClick={(e) => onHide()}>Cancel</Button>
                        <Button className='btn-primary' onClick={(e) => submitHandler()}>Confirm</Button>
                    </>
                }
            >
                 {
                    apiError &&
                    <Alert variant={'danger'}>
                        {apiError?.message || 'Access denied! Please try again'}
                    </Alert>
                 }
                <div style={{textAlign: "center"}}>
                    {
                        "Are you sure you want to delete this ward?"
                    }
                </div>
            </Popup>
            {isLoader && <Loader />}
            {
            isDone &&
            <ApiResponsePopup
                {
                    ...{
                        hideHandlerRes,
                        isRecordUpdated:isDone,
                        title: "Delete Ward",
                        successMsg: 'Ward deleted successfully!',
                    }
                }
            />
           }
        </>
    )
}

export default DeleteWardPopup;